(function () {
  if (window.aanvulrijGeladen) return;
  window.aanvulrijGeladen = true;

  function rij(kaart) {
    return kaart.closest('[data-av-rij]');
  }

  function varianten(kaart) {
    if (!kaart._av) {
      try {
        kaart._av = JSON.parse(kaart.querySelector('[data-av-varianten]').textContent);
      } catch (e) {
        kaart._av = [];
      }
    }
    return kaart._av;
  }

  function opties(kaart) {
    return Array.prototype.slice.call(kaart.querySelectorAll('[data-av-optie]'));
  }

  function waarde(el) {
    return el.tagName === 'SELECT' ? el.value : el.getAttribute('data-waarde');
  }

  function gekozen(kaart) {
    var uit = [];
    opties(kaart).forEach(function (el) {
      uit[+el.getAttribute('data-av-optie')] = waarde(el);
    });
    return uit;
  }

  function past(v, keuze, behalve) {
    for (var i = 0; i < keuze.length; i++) {
      if (i === behalve || !keuze[i]) continue;
      if (v.o[i] !== keuze[i]) return false;
    }
    return true;
  }

  function variant(kaart) {
    var keuze = gekozen(kaart);
    for (var i = 0; i < keuze.length; i++) {
      if (keuze[i] === '' || keuze[i] == null) return null;
    }
    var lijst = varianten(kaart);
    for (var j = 0; j < lijst.length; j++) {
      if (past(lijst[j], keuze, -1)) return lijst[j];
    }
    return null;
  }

  function geld(centen, formaat) {
    var bedrag = (centen / 100).toFixed(2);
    var komma = bedrag.replace('.', ',');
    formaat = formaat || '€{{amount_with_comma_separator}}';
    return formaat.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, soort) {
      if (soort === 'amount') return bedrag;
      if (soort === 'amount_no_decimals') return String(Math.round(centen / 100));
      if (soort === 'amount_no_decimals_with_comma_separator') return String(Math.round(centen / 100));
      return komma;
    });
  }

  function meld(kaart, tekst) {
    var m = kaart.querySelector('[data-av-melding]');
    if (!m) return;
    m.textContent = tekst || '';
    m.hidden = !tekst;
  }

  function werkBij(kaart) {
    var lijst = varianten(kaart);
    var keuze = gekozen(kaart);

    opties(kaart).forEach(function (el) {
      if (el.tagName !== 'SELECT') return;
      var plek = +el.getAttribute('data-av-optie');
      Array.prototype.forEach.call(el.options, function (opt) {
        if (!opt.value) return;
        if (!opt.hasAttribute('data-av-naam')) opt.setAttribute('data-av-naam', opt.textContent);
        var kan = lijst.some(function (v) {
          return v.a && v.o[plek] === opt.value && past(v, keuze, plek);
        });
        opt.disabled = !kan;
        opt.textContent = opt.getAttribute('data-av-naam') + (kan ? '' : ' (uitverkocht)');
      });
    });

    var v = variant(kaart);
    var knop = kaart.querySelector('[data-av-toevoegen]');
    var r = rij(kaart);
    var gat = r ? +r.getAttribute('data-gat') : 0;
    var formaat = r ? r.getAttribute('data-geld') : '';

    if (v) {
      var prijs = kaart.querySelector('[data-av-prijs]');
      if (prijs) prijs.textContent = geld(v.p, formaat);
      var label = kaart.querySelector('[data-av-label]');
      if (label) label.hidden = v.p < gat;
      var foto = kaart.querySelector('[data-av-foto]');
      if (foto && v.f && foto.getAttribute('src') !== v.f) foto.setAttribute('src', v.f);
    }

    if (knop) {
      var op = v && !v.a;
      knop.disabled = !!op;
      knop.textContent = op ? 'Uitverkocht' : 'Voeg toe';
    }
    kaart._avKlaar = true;
  }

  function alles() {
    document.querySelectorAll('[data-av-kaart]').forEach(function (kaart) {
      if (!kaart._avKlaar) werkBij(kaart);
    });
  }

  function markeerLeeg(kaart) {
    var eerste = null;
    opties(kaart).forEach(function (el) {
      var leeg = el.tagName === 'SELECT' && !el.value;
      el.classList.toggle('is-fout', leeg);
      if (leeg && !eerste) eerste = el;
    });
    return eerste;
  }

  function lees(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.querySelector(selector);
  }

  function vervang(sections, handle) {
    var paneel = document.getElementById('Cart-Drawer');
    if (paneel && sections['cart-drawer']) {
      var inhoud = paneel.querySelector('.side-panel-content');
      var stand = inhoud ? inhoud.scrollTop : 0;
      var nieuw = lees(sections['cart-drawer'], '.cart-drawer');
      if (nieuw) paneel.innerHTML = nieuw.innerHTML;
      if (typeof paneel.removeProductEvent === 'function') paneel.removeProductEvent();
      if (typeof paneel.notesToggle === 'function') paneel.notesToggle();

      var nieuweInhoud = paneel.querySelector('.side-panel-content');
      if (nieuweInhoud) nieuweInhoud.scrollTop = paneel.querySelector('[data-av-rij]') ? stand : 0;

      if (handle) {
        var regel = paneel.querySelector('.product-card-small--link[href*="/products/' + handle + '?"]') ||
          paneel.querySelector('.product-card-small--link[href$="/products/' + handle + '"]');
        var kaart = regel && regel.closest('.product-card-small');
        if (kaart) {
          kaart.classList.add('av-nieuw');
          setTimeout(function () { kaart.classList.remove('av-nieuw'); }, 1900);
        }
      }
    }
    var teller = document.getElementById('cart-drawer-toggle');
    if (teller && sections['cart-bubble']) {
      var doel = teller.querySelector('.thb-item-count');
      var bron = lees(sections['cart-bubble'], '.thb-item-count');
      if (doel && bron) doel.innerHTML = bron.innerHTML;
    }
    if (document.getElementById('Cart')) {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    }
  }

  function voegToe(kaart, knop) {
    var leeg = markeerLeeg(kaart);
    if (leeg) {
      meld(kaart, 'Kies eerst je ' + (leeg.getAttribute('aria-label') || 'maat').toLowerCase() + '.');
      leeg.focus();
      return;
    }
    var v = variant(kaart);
    if (!v || !v.a) {
      meld(kaart, 'Deze combinatie is uitverkocht. Kies een andere.');
      return;
    }
    meld(kaart, '');
    knop.classList.add('is-bezig');
    knop.textContent = 'Bezig';

    var titel = kaart.querySelector('.av-kaart__titel');
    var handle = titel ? (titel.getAttribute('href') || '').split('/products/')[1] : '';
    handle = handle ? handle.split(/[?#]/)[0] : '';
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{ id: v.id, quantity: 1, properties: { _aanvulrij: 'ja' } }],
        sections: 'cart-drawer,cart-bubble',
        sections_url: window.location.pathname
      })
    })
      .then(function (r) {
        return r.json().then(function (d) { return { ok: r.ok, d: d }; });
      })
      .then(function (uit) {
        if (!uit.ok || uit.d.status) {
          knop.classList.remove('is-bezig');
          knop.textContent = 'Voeg toe';
          meld(kaart, uit.d.description || uit.d.message || 'Toevoegen lukte niet. Probeer het opnieuw.');
          return;
        }
        vervang(uit.d.sections || {}, handle);
        if (typeof window.dispatchCustomEvent === 'function') {
          window.dispatchCustomEvent('cart:item-added', { product: uit.d.items ? uit.d.items[0] : uit.d });
        }
      })
      .catch(function () {
        knop.classList.remove('is-bezig');
        knop.textContent = 'Voeg toe';
        meld(kaart, 'Toevoegen lukte niet. Probeer het opnieuw.');
      });
  }

  document.addEventListener('change', function (e) {
    var el = e.target;
    if (!el.matches || !el.matches('[data-av-kaart] select[data-av-optie]')) return;
    var kaart = el.closest('[data-av-kaart]');
    el.classList.remove('is-fout');
    meld(kaart, '');
    werkBij(kaart);
  });

  document.addEventListener('click', function (e) {
    var knop = e.target.closest && e.target.closest('[data-av-toevoegen]');
    if (!knop) return;
    e.preventDefault();
    voegToe(knop.closest('[data-av-kaart]'), knop);
  });

  function kijk() {
    var paneel = document.getElementById('Cart-Drawer');
    if (paneel && !paneel._avKijkt) {
      paneel._avKijkt = true;
      new MutationObserver(alles).observe(paneel, { childList: true, subtree: true });
    }
    alles();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', kijk);
  } else {
    kijk();
  }
})();
